import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "row justify-content-center" }
const _hoisted_2 = { class: "col-7" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "row justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-user circle-large",
    style: {"background":"white","color":"#7a7a7a"}
  })
], -1)
const _hoisted_4 = { class: "card mt-4 py-3" }
const _hoisted_5 = { class: "card-body px-4 py-3" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  for: "accessCode",
  class: "form-label"
}, "Access Code", -1)
const _hoisted_7 = ["value"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_9 = { class: "card-body px-4 py-3" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", {
  for: "firstName",
  class: "form-label"
}, "First Name", -1)
const _hoisted_11 = ["readonly"]
const _hoisted_12 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_14 = { class: "card-body px-4 py-3" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", {
  for: "lastName",
  class: "form-label"
}, "Last Name", -1)
const _hoisted_16 = ["readonly"]
const _hoisted_17 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_19 = { class: "card-body px-4 py-3" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", {
  for: "emailAddress",
  class: "form-label"
}, "Email Address", -1)
const _hoisted_21 = ["readonly"]
const _hoisted_22 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_23 = { class: "row justify-content-center" }
const _hoisted_24 = { class: "row justify-content-center mt-3" }
const _hoisted_25 = { class: "smallText text-center" }
const _hoisted_26 = { class: "row justify-content-center mt-4" }

import { onMounted, onUnmounted, ref, Ref, watch } from "vue";
import firebase from "firebase/compat";
import Unsubscribe = firebase.Unsubscribe;
import { doc, getFirestore, onSnapshot } from "firebase/firestore";
import { Employee } from "@/model/employee";
import { EmployeeMapper } from "@/model/mapper/employee-mapper";
import { useRouter } from "vue-router";
import { OrganisationMapper } from "@/model/mapper/organisation-mapper";
import { Organisation, ValidationType } from "@/model/organisation";
import { ApiService } from "@/api-service";
import { getFunctions } from "firebase/functions";
import { EmailUtils } from "@/utilties/email-utils";
import ConfirmationModal from "@/components/ConfirmationModal.vue";
import { DateTime } from "luxon";


const __default__ = {
  name: "EmployeeDetailView",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const router = useRouter();

let employee: Ref<Employee | null> = ref(null);
let loadingEmployee: Ref<boolean> = ref(true);

let organisation: Ref<Organisation | null> = ref(null);
let loadingOrganisation: Ref<boolean> = ref(true);

let firstName: Ref<string | null> = ref(null);
let firstNameError: Ref<string | null> = ref(null);

let lastName: Ref<string | null> = ref(null);
let lastNameError: Ref<string | null> = ref(null);

let emailAddress: Ref<string | null> = ref(null);
let emailAddressError: Ref<string | null> = ref(null);

let organisationSubscription: Unsubscribe | null = null;
let employeeSubscription: Unsubscribe | null = null;

let isEditing: Ref<boolean> = ref(false);
let isSaving: Ref<boolean> = ref(false);

let isShowingEmailInviteModal: Ref<boolean> = ref(false);
let isShowingEmployeeEnabledModal: Ref<boolean> = ref(false);
let isLoadingEnableEmployee: Ref<boolean> = ref(false);
let isLoadingSendInvitation: Ref<boolean> = ref(false);

const db = getFirestore();

async function getOrganisation(organisationId: string) {
  organisationSubscription = onSnapshot(
    doc(db, "organisations", organisationId),
    (doc) => {
      let data = doc.data();
      if (data) {
        organisation.value = OrganisationMapper.toOrganisation(doc.id, data);
      } else {
        console.log("Failed to retrieve organisation. Document data null");
      }
      loadingOrganisation.value = false;
    },
    (error) => {
      console.log("Failed to query organisation", error);
      loadingOrganisation.value = false;
    }
  );
}

async function getEmployee(organisationId: string, employeeId: string) {
  employeeSubscription = onSnapshot(
    doc(db, "organisations/" + organisationId + "/employees", employeeId),
    (doc) => {
      let data = doc.data();
      if (data) {
        employee.value = EmployeeMapper.toEmployee(doc.id, data);
      } else {
        console.log("Failed to retrieve employee. Document data null");
      }
      loadingEmployee.value = false;
    },
    (error) => {
      console.log("Failed to query employee", error);
      loadingEmployee.value = false;
    }
  );
}

const apiService = new ApiService(getFunctions());

function enableEditing() {
  isEditing.value = true;
}

async function editEmployee() {
  let organisationId = organisation.value?.id;
  if (organisationId == null) {
    console.log("Failed to edit employee, organisationId null");
    return;
  }
  let employeeId = employee.value?.id;
  if (employeeId == null) {
    console.log("Failed to edit employee, employeeId null");
    return;
  }
  isSaving.value = true;
  await apiService
    .editEmployees(organisationId, [
      {
        employeeId: employeeId,
        firstName: firstName.value,
        lastName: lastName.value,
        emailAddress: emailAddress.value,
      },
    ])
    .catch((error) => {
      console.log("Failed to edit employees", error);
    });
  isSaving.value = false;
  isEditing.value = false;
}

async function toggleEmployeeEnabled() {
  let organisationId = organisation.value?.id;
  if (organisationId == null) {
    console.log("Failed to edit employee isActive state, organisationId null");
    return;
  }
  let employeeId = employee.value?.id;
  if (employeeId == null) {
    console.log("Failed to edit employee, employeeId null");
    return;
  }
  isLoadingEnableEmployee.value = true;
  await apiService.editEmployees(organisationId, [
    {
      employeeId: employeeId,
      isActive: !employee.value!.isEnabled,
    },
  ]);
  isLoadingEnableEmployee.value = false;
  isShowingEmployeeEnabledModal.value = false;
}

async function inviteEmployee() {
  if (organisation.value == null) {
    console.log("Failed to invite employee, organisation null");
    isShowingEmailInviteModal.value = false;
    return;
  }
  if (employee.value == null) {
    console.log("Failed to invite employee, employee id null");
    isShowingEmailInviteModal.value = false;
    return;
  }
  isLoadingSendInvitation.value = true;
  await apiService.inviteEmployees(
    organisation.value!.id,
    organisation.value!.name,
    [
      {
        employeeId: employee.value.id,
        emailAddress: employee.value.emailAddress!,
        firstName: employee.value.firstName,
      },
    ]
  );
  isLoadingSendInvitation.value = false;
  isShowingEmailInviteModal.value = false;
}

function toggleInviteEmployeeModal(visible: boolean) {
  isShowingEmailInviteModal.value = visible;
}

function toggleEmployeeEnabledModal(visible: boolean) {
  isShowingEmployeeEnabledModal.value = visible;
}

function lastInvited(): string | null {
  if (employee.value == null) {
    return null;
  }
  if (employee.value?.lastInviteDate == null) {
    return null;
  }
  return DateTime.fromJSDate(
    employee.value!.lastInviteDate!.toDate()
  ).toRelative();
}

onMounted(() => {
  let organisationUrl = router.currentRoute.value.params[
    "organisationId"
  ] as string;
  let employeeId = router.currentRoute.value.params["employeeId"] as string;

  getOrganisation(organisationUrl).catch((error) => {
    console.log("Failed to get organisation", error);
  });
  getEmployee(organisationUrl, employeeId).catch((error) => {
    console.log("Failed to get employee", error);
  });
});

onUnmounted(() => {
  if (organisationSubscription != null) {
    organisationSubscription();
  }
  if (employeeSubscription != null) {
    employeeSubscription();
  }
});

watch(
  () => employee.value,
  () => {
    let emailToDisplay = employee.value?.emailAddress;
    if (
      emailToDisplay == null &&
      organisation.value?.validation?.type == ValidationType.email
    ) {
      emailToDisplay = employee.value?.id;
    }
    emailAddress.value = emailToDisplay ?? null;
    firstName.value = employee.value?.firstName ?? null;
    lastName.value = employee.value?.lastName ?? null;
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("input", {
              type: "text",
              class: "form-control",
              id: "accessCode",
              value: _unref(employee)?.id,
              readonly: true
            }, null, 8, _hoisted_7)
          ]),
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: _normalizeClass(["form-control", { 'is-invalid': _unref(firstNameError) }]),
              id: "firstName",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(firstName) ? (firstName).value = $event : firstName = $event)),
              readonly: _unref(isSaving) || !_unref(isEditing)
            }, null, 10, _hoisted_11), [
              [_vModelText, _unref(firstName)]
            ]),
            (_unref(firstNameError) != null)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_unref(firstNameError)), 1))
              : _createCommentVNode("", true)
          ]),
          _hoisted_13,
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: _normalizeClass(["form-control", { 'is-invalid': _unref(lastNameError) }]),
              id: "lastName",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(lastName) ? (lastName).value = $event : lastName = $event)),
              readonly: _unref(isSaving) || !_unref(isEditing)
            }, null, 10, _hoisted_16), [
              [_vModelText, _unref(lastName)]
            ]),
            (_unref(lastNameError) != null)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_unref(lastNameError)), 1))
              : _createCommentVNode("", true)
          ]),
          _hoisted_18,
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _withDirectives(_createElementVNode("input", {
              type: "email",
              class: _normalizeClass(["form-control", { 'is-invalid': _unref(emailAddressError) }]),
              id: "emailAddress",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(emailAddress) ? (emailAddress).value = $event : emailAddress = $event)),
              readonly: 
              _unref(isSaving) ||
              _unref(organisation)?.validation?.type === _unref(ValidationType).email ||
              !_unref(isEditing)
            
            }, null, 10, _hoisted_21), [
              [_vModelText, _unref(emailAddress)]
            ]),
            (_unref(emailAddressError) != null)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(_unref(emailAddressError)), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("button", {
            class: "btn btn-link normal-case mt-5",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(isEditing) ? editEmployee() : enableEditing()))
          }, [
            (_unref(isSaving))
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: _normalizeClass([{ disabled: _unref(isSaving) }, "spinner-border spinner-border-sm"]),
                  role: "status",
                  "aria-hidden": "true"
                }, null, 2))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(_unref(isEditing) ? "Save" : "Edit"), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("button", {
            class: _normalizeClass(["btn btn-link normal-case", {
            disabled: !_unref(EmailUtils).sendEmailAllowed(_unref(organisation), _unref(employee)),
          }]),
            onClick: _cache[4] || (_cache[4] = ($event: any) => (toggleInviteEmployeeModal(true)))
          }, " Send Invite ", 2),
          _createElementVNode("span", _hoisted_25, "Last invited: " + _toDisplayString(lastInvited() ?? "Never"), 1)
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("button", {
            class: "btn btn-link normal-case text-danger",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (toggleEmployeeEnabledModal(true)))
          }, _toDisplayString(_unref(employee)?.isEnabled ? "Disable Employee" : "Enable Employee"), 1)
        ])
      ])
    ]),
    _createVNode(ConfirmationModal, {
      "cancel-button-text": "Cancel",
      "confirm-button-text": "Send",
      "is-visible": _unref(isShowingEmailInviteModal),
      loading: _unref(isLoadingSendInvitation),
      title: "Confirm Email",
      message: 
      'Are you sure you want to send an invite to ' +
      _unref(employee)?.emailAddress +
      '?'
    ,
      onConfirm: _cache[6] || (_cache[6] = ($event: any) => (inviteEmployee())),
      onCancel: _cache[7] || (_cache[7] = ($event: any) => (toggleInviteEmployeeModal(false))),
      onHideModal: _cache[8] || (_cache[8] = ($event: any) => (toggleInviteEmployeeModal(false)))
    }, null, 8, ["is-visible", "loading", "message"]),
    _createVNode(ConfirmationModal, {
      "cancel-button-text": "Cancel",
      "confirm-button-text": _unref(employee)?.isEnabled ? 'Disable' : 'Enable',
      "is-visible": _unref(isShowingEmployeeEnabledModal),
      loading: _unref(isLoadingEnableEmployee),
      title: 
      _unref(employee)?.isEnabled
        ? 'Confirm Disable Employee'
        : 'Confirm Enable Employee'
    ,
      message: 
      'Are you sure you want to ' +
      (_unref(employee)?.isEnabled ? 'disable ' : 'enable ') +
      _unref(employee)?.friendlyName() +
      '?'
    ,
      onConfirm: _cache[9] || (_cache[9] = ($event: any) => (toggleEmployeeEnabled())),
      onCancel: _cache[10] || (_cache[10] = ($event: any) => (toggleEmployeeEnabledModal(false))),
      onHideModal: _cache[11] || (_cache[11] = ($event: any) => (toggleEmployeeEnabledModal(false)))
    }, null, 8, ["confirm-button-text", "is-visible", "loading", "title", "message"])
  ], 64))
}
}

})